(function ($) {
	$(function () {
		$(".photos").addClass("swiper");
		$(".photos > ul").addClass("swiper-wrapper");
		$(".photos > ul > li").addClass("swiper-slide");
		$(".photos > ul").after('<li class="next"></li>');
		$(".photos > ul").after('<li class="prev"></li>');
		$(".thumbnails").addClass("swiper");
		$(".thumbnails > ul").addClass("swiper-wrapper");
		$(".thumbnails > ul > li").addClass("swiper-slide");

		let thumbnails	=	new Swiper(".thumbnails", {
			loop			:	true,
			slidesPerView	:	4,
			spaceBetween	:	10,
		});

		let photos	=	new Swiper(".photos", {
			loop			:	true,
			navigation	:	{
				nextEl	: ".next",
				prevEl	: ".prev",
			},
			thumbs	:	{
				swiper	:	thumbnails,
			},
		});
		
		let adjust	=	0;

		$(".minus").on("mousedown touchstart", function () {
			adjust	=	-1;
		});

		$(".plus").on("mousedown touchstart", function () {
			adjust	=	1;
		});

		$(".minus, .plus").on("mouseup touchend mouseleave", function () {
			adjust	=	0;
		});

		setInterval(function () {
			if(adjust != 0) {
				let number	=	$("input[name=product_num]").val() - 0 + adjust;

				if(number <= 0) {
					number	=	1;
				}
				else if(number > 100) {
					number	=	100;
				}
				$("input[name=product_num]").val(number);
				
			}
		}, 200);
	});
})(jQuery);